<div class="w-100 mt-0 tool-container">
  <h4>Custom Report Request</h4>
  <mat-form-field class="me-3">
    <mat-label>Application</mat-label>
    <mat-select [(ngModel)]="customReportDownloadApp">
      @for (app of applications; track app.value) {
        <mat-option [value]="app.value">
          {{ app.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="payload-input me-2">
    <mat-label>Payload Data</mat-label>
    <textarea matInput [(ngModel)]="customReportInput"></textarea>
  </mat-form-field>
  <span class="radio-container ps-2 me-3">
    <mat-label>Download As</mat-label>
    <mat-radio-group [(ngModel)]="customReportDownloadType">
      <mat-radio-button [value]="'text/html'" checked class="me-3"
        >HTML</mat-radio-button
      >
      <mat-radio-button [value]="'application/pdf'">PDF</mat-radio-button>
    </mat-radio-group>
  </span>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="customReportRequest()"
    [disabled]="!(customReportInput && customReportDownloadType)"
  >
    Request
  </button>
  @if (customReportStatus) {
    <h4 class="col-12 {{ customReportStatusClass }}">
      {{ customReportStatus }}
    </h4>
  }
  <div>
    Notes:<ol>
      <li>This request can take some time to complete</li>
      <li>
        Be sure to check the response file contents as the request may still
        return a file in the event of an error
      </li>
      <li>
        Enter complete JSON data into text box. Example:

        <pre>
&#123; "ReportType": "template", "UIConfig": "mmreport", "ProfileID": "PROFILE ID HERE" &#125;</pre
        >
        <pre>
&#123; "ReportType": "template", "UIConfig": "rbreport", "ProfileID": "PROFILE ID HERE" &#125;</pre
        >
      </li>
    </ol>
  </div>
</div>
